import { render } from "./InjurySexAlysis.vue?vue&type=template&id=0dd806f9&scoped=true"
import script from "./InjurySexAlysis.vue?vue&type=script&lang=js"
export * from "./InjurySexAlysis.vue?vue&type=script&lang=js"

import "./InjurySexAlysis.vue?vue&type=style&index=0&id=0dd806f9&lang=scss&scoped=true"
import "./InjurySexAlysis.vue?vue&type=style&index=1&id=0dd806f9&lang=scss&scoped=true"
import "./InjurySexAlysis.vue?vue&type=style&index=2&id=0dd806f9&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd806f9"]])

export default __exports__